import { METHODS } from "../../config";
import { ENDPOINTS } from "../../config/endpoints";
import { fetchData } from "../../utils/fetchData";

export const getComingSoonPrivacyPage = async () => {
  const data = await fetchData(ENDPOINTS.GET.COMING_SOON_PRIVACY, {
    method: METHODS.GET,
  });
  return data;
};
